import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const PaymentCouponsTitle = ({ isPromocodeEnabled, hasUsableCredits }) => {
	if (isPromocodeEnabled && !hasUsableCredits) {
		return <FormattedMessage id="payment.coupons.title.promocode.only" />;
	} else if (!isPromocodeEnabled && hasUsableCredits) {
		return <FormattedMessage id="payment.coupons.title.credits.only" />;
	} else if (isPromocodeEnabled && hasUsableCredits) {
		return <FormattedMessage id="payment.coupons.title.credits.and.promocode" />;
	}
	return "";
};

PaymentCouponsTitle.propTypes = {
	isPromocodeEnabled: PropTypes.bool,
	hasUsableCredits: PropTypes.bool,
};

export default React.memo(PaymentCouponsTitle);
